import { CreateProviderParams, IGuarantor, IUserProviderItem } from 'types/provider.types';
import { memberApiV2 } from '@lib/api';
import { TPaginatedResult } from 'types/pagination.types';
import { ISearchedProvider, TProviderSearchParams } from 'types/provider.types';
import {
  IWorkspaceDetail,
  SearchWorkspaceParams,
  TSearchWorkspaceRes,
} from 'types/workspace.types';

export function searchProviders(params?: TProviderSearchParams) {
  return memberApiV2.request<{ data: TPaginatedResult<ISearchedProvider> }>(
    '/management/public/user/providers',
    {
      method: 'POST',
      data: params,
    },
  );
}

export function getUsersProviders() {
  return memberApiV2.request<{ data: IUserProviderItem[] }>('/management/public/user/providers', {
    method: 'GET',
  });
}

export function createProvider(data: CreateProviderParams) {
  return memberApiV2.request<{ data: { providerId: string } }>(
    '/management/public/provider/create',
    {
      method: 'POST',
      data,
    },
  );
}

export function getWorkspaceDetail(providerId: string, workspaceId: string) {
  return memberApiV2.request<{ data: IWorkspaceDetail }>(
    `/management/private/workspace/${workspaceId}`,
    {
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function uploadWorkspaceImage(providerId: string, workspaceId: string, image: File) {
  const data = new FormData();
  data.append('image', image);

  return memberApiV2.request(`/management/private/workspace/image/${workspaceId}`, {
    data,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
      'provider-id': providerId,
    },
  });
}

export function createWorkspace(providerId: string, data: any) {
  return memberApiV2.request<{ data: { workspaceId: string } }>(`/management/private/workspace`, {
    data,
    method: 'POST',
    headers: {
      'provider-id': providerId,
    },
  });
}

export function updateWorkspace(providerId: string, workspaceId: string, data: any) {
  return memberApiV2.request(`/management/private/workspace/${workspaceId}`, {
    data,
    method: 'PUT',
    headers: {
      'provider-id': providerId,
    },
  });
}

export function addWorkspaceWorker(
  providerId: string,
  workspaceId: string,
  worker: {
    userId: string;
    hasEVisit: boolean;
  },
) {
  return memberApiV2.request(`/management/private/workspace/workers/${workspaceId}`, {
    data: worker,
    method: 'POST',
    headers: {
      'provider-id': providerId,
    },
  });
}

export function updateWorkspaceWorker(
  providerId: string,
  workspaceId: string,
  worker: {
    userId: string;
    hasEVisit: boolean;
  },
) {
  return memberApiV2.request(
    `/management/private/workspace/workers/${workspaceId}/${worker.userId}`,
    {
      data: worker,
      method: 'PATCH',
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function searchWorkspaces(providerId: string, data: SearchWorkspaceParams) {
  return memberApiV2.request<{ data: TSearchWorkspaceRes }>(
    '/management/private/workspace/search',
    {
      method: 'POST',
      data,
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function addGuarantor(providerId: string, data: IGuarantor) {
  return memberApiV2.request('/management/private/provider/add-guarantor', {
    method: 'POST',
    data,
    headers: {
      'provider-id': providerId,
    },
  });
}
